import styled from 'styled-components'
import { Colors, Spacing } from 'cio-design-library/design-tokens'
import { Icon24 } from 'builder/components/Icon'
import Typography, { FontWeights } from 'builder/styles/typography'

export const Container = styled.div`
  width: 100%;
  display: flex;
  gap: ${Spacing['2XS']};
  padding: ${Spacing.XS};
  background-color: ${Colors.Blue10};
  border-radius: ${Spacing['2XS']};
`

export const Text = styled.p`
  ${Typography.Caption};
  color: ${Colors.Neutral90};

  & > span {
    ${FontWeights.DemiBold};
  }
`

export const IconContainer = styled.div`
  display: flex;
`

export const Icon = styled(Icon24.Info)`
  width: 20px;
  height: 20px;
  color: ${Colors.Blue50};
`
